import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { deleteMessageSession } from '../../../state/message/messageSessionSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';

export function* leaveConversationSaga(action) {
    const { messageSessionId } = action.payload;
    try {
        const { domain, user } = yield select(selectUserCredentials);
        const response = yield call(cirrusClient.put,
            `/v2/domains/${domain}/users/${user}/messagesessions/${messageSessionId}/leave`,
        );

        if (response.status === 202) {
            
            // Remove the message session locally
            yield put(deleteMessageSession(messageSessionId));

            yield put(showSnackbar({
                message: 'You have left the conversation successfully',
                severity: 'success'
            }));
        }
    } catch (error) {
        console.error('Error leaving conversation:', error);
        yield put(showSnackbar({
            message: 'Unable to leave conversation. Please try again.',
            severity: 'error'
        }));
    }
}